/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Salty_Bee_BreatheInputs */

const fr_weak_salty_bee_breathe = /** @type {(inputs: Weak_Salty_Bee_BreatheInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter la section`)
};

/**

* @param {Weak_Salty_Bee_BreatheInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const weak_salty_bee_breathe = /** @type {((inputs?: Weak_Salty_Bee_BreatheInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Salty_Bee_BreatheInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_weak_salty_bee_breathe(inputs)
});